import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaPsicometricasInterface } from "../../../../../interfaces/FechaPsicometricasInterface";
import { SemaforoPsiInterface } from "../../../../../interfaces/SemaforoPsiInterface";
import { ConclusionesPsiInterface } from "../../../../../interfaces/ConclusionesPsiInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const ConclusionesPSMPrint = () => {
  const tituloFormulario = "CONCLUSIÓN PSICOMETRICA";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setSelectedRecommendation(value);
    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaPSI = useGetData<FechaPsicometricasInterface[]>({
    url: `/fecha_psicometricas/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_psicometricas"],
  });

  const querySemaforoPSI = useGetData<SemaforoPsiInterface>({
    url: `/semaforo_psi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforo_psi"],
  });

  const queryConclusionesPSI = useGetData<ConclusionesPsiInterface[]>({
    url: `/conclusiones_psi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusiones_psi"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaPSI.data && queryFechaPSI.data.length > 0) {
      const fechaPSI = queryFechaPSI.data[0];
      reset({
        fecha_conclusionpsi: fechaPSI.fecha_conclusionpsi || "",
        evaluado_uuid: fechaPSI.evaluado_uuid || "",
      });
    }
  }, [queryFechaPSI.data, reset]);

  useEffect(() => {
    if (querySemaforoPSI.data) {
      const color = querySemaforoPSI.data.color_psi || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_psi: color,
        evaluado_uuid: querySemaforoPSI.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoPSI.data, reset]);

  useEffect(() => {
    if (queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0) {
      const notasPSI = queryConclusionesPSI.data[0];
      reset({
        motivo_psicom: notasPSI.motivo_psicom || "",
        tipo_psicom: notasPSI.tipo_psicom || "",
        nota_1psicom: notasPSI.nota_1psicom || "",
        nota_2psicom: notasPSI.nota_2psicom || "",
        nota_3psicom: notasPSI.nota_3psicom || "",
        resultado_psicom: notasPSI.resultado_psicom || "",
        evaluado_uuid: notasPSI.evaluado_uuid || "",
      });
    }
  }, [queryConclusionesPSI.data, reset]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA:
            </Label>
            <Controller
              name="fecha_conclusionpsi"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_conclusionpsi"
                  type="date"
                  value={
                    field.value ||
                    (queryFechaPSI.data && queryFechaPSI.data.length > 0
                      ? queryFechaPSI.data[0]?.fecha_conclusionpsi || ""
                      : "")
                  }
                  disabled={true}
                  onChange={(e) => field.onChange(e.target.value)}
                  className="text-center w-full"
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* FOTO */}
          <div className="w-40 h-40 border border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center mt-4 relative z-10">
            {photoUrl ? (
              <img
                src={photoUrl}
                alt="Foto de evaluado"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-gray-500">Sin foto disponible</span>
            )}
          </div>
          {/* SEMAFORO */}
          <div className="flex items-center gap-4">
            {selectedRecommendation && (
              <>
                {/* Radio buttons */}
                <div className="flex flex-col">
                  <label className="flex items-center gap-2 mt-4 mb-4">
                    <input
                      type="radio"
                      name="recommendation"
                      value="recomendable"
                      checked={selectedRecommendation === "recomendable"}
                      onChange={handleRadioChange}
                      disabled={true}
                    />
                    RECOMENDABLE
                  </label>
                  <label className="flex items-center gap-2 mt-12 mb-12">
                    <input
                      type="radio"
                      name="recommendation"
                      value="con_reserva"
                      checked={selectedRecommendation === "con_reserva"}
                      onChange={handleRadioChange}
                      disabled={true}
                    />
                    CON RESERVA
                  </label>
                  <label className="flex items-center gap-2 mb-12">
                    <input
                      type="radio"
                      name="recommendation"
                      value="no_recomendable"
                      checked={selectedRecommendation === "no_recomendable"}
                      onChange={handleRadioChange}
                    />
                    NO RECOMENDABLE
                  </label>
                </div>
                {/* Imagen de Semaforo */}
                <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
              </>
            )}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Motivo de la evaluación */}
          <div className="col-span-1">
            <Label htmlFor="motivo_psicom">MOTIVO DE LA EVALUACIÓN:</Label>
            <Controller
              name="motivo_psicom"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="motivo_psicom"
                  type="text"
                  value={
                    field.value ||
                    (queryConclusionesPSI.data &&
                    queryConclusionesPSI.data.length > 0
                      ? queryConclusionesPSI.data[0]?.motivo_psicom || ""
                      : "")
                  }
                  disabled={true}
                  onChange={(e) => field.onChange(e.target.value)}
                  className="w-full"
                />
              )}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="tipo_psicom">TIPO:</Label>
            <Controller
              name="tipo_psicom"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="tipo_psicom"
                  type="text"
                  value={
                    field.value ||
                    (queryConclusionesPSI.data &&
                    queryConclusionesPSI.data.length > 0
                      ? queryConclusionesPSI.data[0]?.tipo_psicom || ""
                      : "")
                  }
                  onChange={(e) => field.onChange(e.target.value)}
                  className="w-full"
                  disabled={true}
                />
              )}
            />
          </div>
        </div>
      </div>
      <div className="mt-[300px]"></div>
      <div className="w-full">
        {" "}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-3 rounded-t">
          {" "}
          <h1 className="text-xl font-bold text-white text-center uppercase tracking-wide">
            {" "}
            Resultado General
          </h1>
        </div>
      </div>
      {/* Sección de Notas */}
      <div className="flex flex-col items-center border-dashed border-4 border-gray-300 rounded-lg p-8 bg-gray-100 space-y-4 relative">
        <div className="w-full mt-4">
          <span className="mb-2 text-justify block">
            Se realizó una valoración, análisis y revisión con la finalidad de
            identificar los riesgos en conjunto, dado lo anterior se encontró lo
            siguiente en el proceso de evaluación:
          </span>
          <span className="mb-2 text-justify block">
            Se considera que es una{" "}
            <strong>
              PERSONA{" "}
              {querySemaforoPSI.data?.color_psi === "verde"
                ? "RECOMENDABLE"
                : querySemaforoPSI.data?.color_psi === "amarillo"
                ? "CON RESERVA"
                : querySemaforoPSI.data?.color_psi === "rojo"
                ? "NO RECOMENDABLE"
                : ""}
            </strong>{" "}
            ya que:
          </span>
          <label
            htmlFor="nombre"
            className="text-gray-800 font-normal inline-block text-justify"
          >
            {queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0
              ? (queryConclusionesPSI.data[0]?.nota_1psicom || "")
                  .split("\n")
                  .map((paragraph, index) => (
                    <p key={index} className="mb-2">
                      {" "}
                      {paragraph}
                    </p>
                  ))
              : ""}
          </label>
          <span className="mt-2 mb-2 text-justify block">
            Al momento de la evaluación se observó también lo siguiente:
          </span>
          <label
            htmlFor="nombre"
            className="text-gray-800 font-normal inline-block text-justify"
          >
            {queryConclusionesPSI.data && queryConclusionesPSI.data.length > 0
              ? (queryConclusionesPSI.data[0]?.nota_2psicom || "")
                  .split("\n")
                  .map((paragraph, index) => (
                    <p key={index} className="mb-2">
                      {" "}
                      {paragraph}
                    </p>
                  ))
              : ""}
          </label>
        </div>
      </div>
      <div className="mt-2 col-span-1">
        <Label htmlFor="resultado_psicom">RESULTADO:</Label>
        <Controller
          name="resultado_psicom"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <input
              type="text"
              id="resultado_psicom"
              value={
                field.value ||
                (queryConclusionesPSI.data &&
                queryConclusionesPSI.data.length > 0
                  ? queryConclusionesPSI.data[0]?.resultado_psicom || ""
                  : "")
              }
              onChange={(e) => field.onChange(e.target.value)}
              className="text-left w-[300px] border rounded"
              disabled={true}
            />
          )}
        />
      </div>
      <div className="mt-2 flex items-center gap-2">
        <div className="flex items-center gap-1">
          <Label htmlFor="FirmaRealizo" className="text-sm whitespace-nowrap">
            FIRMA REALIZÓ:
          </Label>
          <TextInput
            id="FirmaRealizo"
            name="FirmaRealizo"
            disabled={true}
            className="h-8 text-sm w-full"
          />
        </div>
        <div className="flex items-center gap-1">
          <Label htmlFor="FirmaReviso" className="text-sm whitespace-nowrap">
            FIRMA REVISÓ:
          </Label>
          <TextInput
            id="FirmaReviso"
            name="FirmaReviso"
            disabled={true}
            className="h-8 text-sm w-full"
          />
        </div>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[250%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
    </div>
  );
};
